import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import * as Rx from 'rxjs';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpErrorResponse, HttpHandler } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { GooglAnalyticsService } from './googleAnalyticsService';
import { UserInfoService } from './user/user-info.service';

@Injectable({providedIn: 'root'})
class AuthMonitorService {
	constructor (
		private pageTitle: Title,
		private userInfo: UserInfoService,
		private router: Router
	) {}

	canActivate (next: ActivatedRouteSnapshot): Rx.Observable<boolean> | Promise<boolean> | boolean 
	{
		if (next.data["externalUrl"] != null) {
			let loc: string = next.data["externalUrl"];
			if (next.queryParams != null) {
				let vls: string[] = [];
				Object.keys(next.queryParams).forEach((key) => {
					vls.push(encodeURIComponent(key) + "=" + encodeURIComponent(next.queryParams[key]));
				});
				if (vls.length > 0) {
					loc += "?" + vls.join("&");
				}
			}
			window.location.href = loc;
			return false;
		}
		else {
			let routeData = next.data;
			if (routeData["authenticate"] && this.userInfo.isAnonymous()) {
				this.router.navigateByUrl("/User/Login");
				return false;
			}
			else {
				//update page title
				this.pageTitle.setTitle(routeData["routeName"]);
				return true;
			}
		}
	}
}

export const AuthMonitor: CanActivateFn = (next: ActivatedRouteSnapshot) => {
	return inject(AuthMonitorService).canActivate(next);
}

@Injectable({ providedIn: 'root' })
export class MonitorHTTP implements HttpInterceptor {
	constructor(private analytics: GooglAnalyticsService) { }

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Rx.Observable<HttpEvent<unknown>> {
		const started = Date.now();
		let status: number;
		return next.handle(request).pipe(
			Rx.finalize(() => {
				const elapsed = Date.now() - started;
				this.analytics.trackApiCall(request.urlWithParams, request.method, status, elapsed);
			}),
			Rx.catchError((error: HttpErrorResponse) => {
				// 505, HttpVersionNotSupported / maintenance
				if (error.status === 505) {
					window.location.href = "assets/maintenance.html?tm=" + Date.now();
				}
				return Rx.throwError(() => error);
			})
		)
	}
}
